import "./query_logic.html";

export default function queryLogic() {
    return {
        restrict: 'EA',
        templateUrl: "/app/query/ocom_query/query_logic.html",
        scope: {
            filterOption: '=',
            filterRow: "=",
            metaData: '=',
            specialOptions: '='
        },
        controller: function ($scope) {
            $scope.logic = [{id: "and", name: "And"}, {id: "or", name: "Or"}];

            function makeSureRowStructureIsGood(row) {
                if (!row.criteria) {
                    row.criteria = [];
                }
                if (!row.logic) {
                    row.logic = "and";
                }
            }

            $scope.addCondition = function (row) {
                makeSureRowStructureIsGood(row);

                row.criteria.push({name: null, operation: null, params: [], special: ''})
            }
            $scope.addLogic = function (row) {
                makeSureRowStructureIsGood(row);

                row.criteria.push({logic: 'and', criteria: []})
            }
        }

    };
}